import CardCommon from '@op/components/CardCommon';
import React, { useMemo } from 'react';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import './index.scss';
import { useLocalLanguage } from '@op/utils/languageValue';
import { reviewsFormat } from '@op/utils/value';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { formatDateFunc } from '@op/utils/time';
import SmallChart from '@op/pages/Summary/components/SmallChart';
import { keyOpinionsRisingTopics } from '@op/components/BubbleCommon/copywritingKey/keyOpinions';
import { useLocation } from 'umi';
import {
  useDrilldownParams,
  EDrilldownMode,
} from '@op/hooks/useDrilldownParams';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import moment from 'moment';
import { useKeyOpinionsRisingTopic } from '@op/pages/Overview/KeyOpinions/hook';

export default function RisingTopics({
  languageType,
  filter,
  gameInfo,
  translateTopic,
  contentCard = true,
  itemClick,
  loadingHeight = 380,
  emptyHeight = 380,
}: any) {
  const { language, formatMessage } = useLocalLanguage({
    languageType: languageType || 'origin',
  });
  const pageUrlInfo = useLocation();
  const pageUrlObj = pageUrlInfo?.query || {};

  const { data, loading } = useKeyOpinionsRisingTopic({
    filter,
    extraData: pageUrlObj,
  });

  const { goPage } = useDrilldownParams();
  const goTopicDetails = (name = '') => {
    if (name) {
      buriedBtnPoint('KONO_ClickTopic', name);
    }

    if (itemClick) {
      return itemClick(name);
    }

    // TopicTracking 为特殊页面，走本地缓存（Local 模式）；topicLevel 通过 stats 透传到 history.state
    goPage({
      path: '/opinion/Summary/TopicTracking',
      filter: {
        ...filter,
        ...gameInfo,
        topic: name ? [name] : [],
      },
      mode: EDrilldownMode.Local,
      stats: {
        topicLevel: 'L2',
      },
    });
  };

  const formatDate = useMemo(() => {
    if (filter.date_type === 'monthly') {
      return formatDateFunc('daily');
    }
    if (
      filter.date_type === 'daily' &&
      moment(filter.start_time).isSame(moment(), 'day') &&
      moment(filter.end_time).isSame(moment(), 'day')
    ) {
      return formatDateFunc('hourly');
    }
    return formatDateFunc(filter.date_type);
  }, [filter]);

  return (
    <CardCommon
      className="dbo-rising-topic"
      title={
        <div className="dbo-rising-topic-title">
          <span> {formatMessage({ id: 'Rising Topics' })}</span>
          <BubbleCommon tipsMap={keyOpinionsRisingTopics} placement={'top'} />
        </div>
      }
      loading={loading}
      empty={data?.length === 0}
      loadingHeight={loadingHeight}
      emptyHeight={emptyHeight}
      hasTitleArrow
      handleTitleOnClick={goTopicDetails}
      logBtnId="KONO_Topic"
      contentCard={contentCard}
    >
      <div className="dbo-rising-topic-list">
        {data?.map((val) => {
          const {
            name,
            mentions,
            old_mentions,
            rising,
            oldTime,
            newTime,
            xAxisData,
            yAxisData,
          } = val;
          const { date_type: dateType } = filter;
          return (
            <CardCommon
              className="dbo-topic-card-common"
              title={translateTopic(name)}
              hasTitleArrow
              contentCard
              key={name}
              handleTitleOnClick={() => goTopicDetails(name)}
            >
              <div className="dbo-numbers-flex">
                <div className="dbo-numbers-flex-content">
                  <div className="dbo-numbers-flex-num">
                    {reviewsFormat(mentions)}
                  </div>
                  <div className="dbo-numbers-flex-trend">
                    <RingRatioBubble
                      formateValue={reviewsFormat}
                      formateDate={formatDate}
                      oldTime={oldTime}
                      newTime={newTime}
                      oldValue={old_mentions}
                      newValue={mentions}
                      title={formatMessage({ id: 'Mentions' })}
                    >
                      <PercentageItem percentage={rising} />
                    </RingRatioBubble>
                  </div>
                </div>
                <div className="dbo-numbers-flex-chart">
                  <SmallChart
                    text={formatMessage({ id: 'Mentions' })}
                    statistics={{ x: xAxisData, y: yAxisData }}
                    name={translateTopic(name)}
                    formatValueFunc={(value: number) =>
                      reviewsFormat(value, 2, '-')
                    }
                    dateType={dateType}
                  />
                </div>
              </div>
            </CardCommon>
          );
        })}
      </div>
    </CardCommon>
  );
}
